export default __webpack_public_path__ + "static/media/faq.1e711909.svg";